import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from 'firebase/functions';
import { FunctionName } from '@verify/shared-components/helpers';
import { Observable, from, map } from 'rxjs';
import { ChangeNotifierService } from './change-notifier.service';
import { FIREBASE_FUNCTIONS } from './firebase.tokens';

@Injectable({
  providedIn: 'root',
})
export class FunctionService {
  private functions: Functions = inject(FIREBASE_FUNCTIONS);
  private changeNotifier = inject(ChangeNotifierService);

  constructor() {}

  call<InputT, OutputT>(
    functionName: FunctionName,
    input: InputT,
    options?: { timeout?: number },
  ): Observable<OutputT> {
    const callable = httpsCallable<InputT, OutputT>(
      this.functions,
      functionName,
      options || {},
    );
    return from(callable(input)).pipe(
      map((result) => result.data),
      this.changeNotifier.notifyOnEmit(),
    );
  }
}
